<template>
  <v-card class="mx-auto">

    <v-expansion-panels multiple>

      <v-expansion-panel>
        <v-expansion-panel-header class="exp-header primary-exp">
          {{ $t("SYSTEM_ACADEMIC_YEAR") }}
        </v-expansion-panel-header>

        <v-expansion-panel-content>
          <v-form ref="yearForm" v-model="yearValid" lazy-validation style="padding-top: 20px;">

            <v-alert v-if="yearError" outlined type="error">
              {{ yearError }}
            </v-alert>

            <v-row>
              <v-col cols="6" md="6">
                <v-select
                    v-model="yearSemester.academicYear"
                    :items="academicYears"
                    :label="$t('ACADEMIC_YEAR')"
                    :rules="requiredRules"
                    dense
                    item-text="label"
                    item-value="value"
                    outlined
                />
              </v-col>

              <v-col cols="6" md="6">
                <v-select
                    v-model="yearSemester.semester"
                    :items="semesters"
                    :label="$t('ACADEMIC_SEMESTER')"
                    :rules="requiredRules"
                    dense
                    hide-details
                    item-text="label"
                    item-value="value"
                    outlined
                />
              </v-col>
            </v-row>

            <v-btn color="primary" dark @click="updateYearSemester">
              {{ $t("SAVE") }}
            </v-btn>

          </v-form>
        </v-expansion-panel-content>
      </v-expansion-panel>


      <!-- ================= PREQUAL YEARS ================= -->

      <v-expansion-panel style=" padding-top: 10px;">
        <v-expansion-panel-header class="exp-header primary-exp">
          {{ $t("ALLOWED_PREQUAL_YEAR") }}
        </v-expansion-panel-header>

        <v-expansion-panel-content>
          <v-form ref="prequalForm" v-model="prequalValid" lazy-validation>
            <v-container>

              <v-alert v-if="prequalError" dense outlined type="error">
                {{ prequalError }}
              </v-alert>

              <v-row>
                <v-col cols="6">
                  <v-autocomplete
                      v-model="prequal.allowedYears"
                      :items="prequalYears"
                      :label="$t('ALLOWED_PREQUAL_YEAR')"
                      :rules="[v => v.length > 0 || $t('PULLING_STEPPER.RULES.AT_LEAST_ONE_YEAR')]"
                      chips
                      clearable
                      item-text="label"
                      item-value="hrId"
                      multiple
                      outlined
                  />

                </v-col>
              </v-row>

              <v-btn color="primary" dark @click="updatePrequal">
                {{ $t("SAVE") }}
              </v-btn>

            </v-container>
          </v-form>
        </v-expansion-panel-content>
      </v-expansion-panel>

    </v-expansion-panels>
  </v-card>
</template>


<script>
import globalMethodsMixin from "@/mixins/globalMethods.ts";
import serverTranslationsMixin from "@/mixins/serverTranslations.ts";

export default {
  name: "pr-changePassword",
  mixins: [serverTranslationsMixin, globalMethodsMixin],
  data() {
    return {
      yearSemester: {
        academicYear: null,   // attribute_id
        semester: null        // attribute_id
      },

      academicYears: [],
      semesters: [],

      yearValid: true,
      yearError: "",

      requiredRules: [
        v => !!v || this.$t("REQUIRED_FIELD")
      ],
      prequalValid: true,
      prequalError: "",

      prequal: {
        allowedYears: []   // [2024, 2023]
      },

      prequalYears: [],    // قائمة السنوات
      activeAcademicYear: null // 2025

    };
  },


  created() {
    this.loadYearsAndSemesters();     // load lists
    this.loadActiveYearSemester();    // load current active
    this.loadPrequalRule();    // load current active
  },

  methods: {
    updatePrequal() {
      this.prequalError = "";
      if (!this.$refs.prequalForm.validate()) return;
      const value1 = this.prequal.allowedYears;
      const payload = {value1};
      this.$http
          .put('/api/general_data/update_prequal_rule/', payload)
          .then(res => {
                this.showToasted("success", res.data.message);
                this.loadPrequalRule();
              },
              err => {
                this.showToasted("error", err.response.data.message)
                this.loadPrequalRule();
              })
    }
    ,
    loadPrequalRule() {
      this.$http
          .get('/api/general_data/list_prequal_rule/')
          .then(res => {

            if (!res.data.data || !res.data.data.value1) {
              this.prequal.allowedYears = [];
              return;
            }

            // backend stores hrIds as comma separated string
            const prequalHrIds = res.data.data.value1
                .split(',')
                .map(v => v.trim())
                .filter(v => v); // remove empty

            // 👈 لأن item-value = hrId
            this.prequal.allowedYears = prequalHrIds;
          })
          .catch(() => {
            this.showToasted(
                "error",
                this.$t('ERROR_MESSAGES.RETRIEVE_DATA_ERROR')
            );
          });
    }

    ,
    loadYearsAndSemesters() {
      this.$http
          .get("/api/general_data/retrive_user_academic_years_semesters/")
          .then(res => {
            this.academicYears = res.data.data.years.map(y => ({
              value: y.attribute_id,
              label: y.attributeName,
              hrId: y.hr_id
            }));
            this.prequalYears = this.academicYears
            this.semesters = res.data.data.semesters.map(s => ({
              value: s.attribute_id,
              label: this.serverTranslate(s.attributeName),
              hrId: s.hr_id
            }));
            this.loadPrequalRule();
          })
          .catch(err => {
            this.showToasted("error", this.$t('ERROR_MESSAGES.RETRIEVE_DATA_ERROR'));
          });
    },

    loadActiveYearSemester() {
      this.$http
          .get("/api/general_data/retrive_user_academic_years_semesters/?active=1")
          .then(res => {
            if (res.data.data.years.length > 0) {
              this.yearSemester.academicYear =
                  res.data.data.years[0].attribute_id;
              const yearText = res.data.data.years[0].attributeName; // "2025-2026"
              this.activeAcademicYear = parseInt(yearText.split('-')[0]);
            }

            if (res.data.data.semesters.length > 0) {
              this.yearSemester.semester =
                  res.data.data.semesters[0].attribute_id;
            }
          })
          .catch(err => {
            this.showToasted("error", this.$t('ERROR_MESSAGES.RETRIEVE_DATA_ERROR'))
          });
    },

    updateYearSemester() {
      this.yearError = "";
      if (!this.$refs.yearForm.validate()) return;
      const payload = {
        yearHrId: this.academicYears.find(item => item.value === this.yearSemester.academicYear) ['hrId'],
        semesterHrId: this.semesters.find(item => item.value === this.yearSemester.semester) ['hrId']
      };

      this.$http
          .put("/api/general_data/update_active_years_semesters/", payload)
          .then(res => {
                this.showToasted("success", res.data.message);
                this.loadActiveYearSemester();
              },
              err => {
                this.showToasted("error", err.response.data.message)
                this.loadActiveYearSemester();
              })
    }
  }
};
</script>


<style>
.primary-exp {
  background-color: rgb(28, 196, 205);
  color: #fff;
}

.primary-exp:hover {
  background-color: rgb(22, 170, 178);
}


</style>


